module.exports = __webpack_public_path__ + "img/hong_kong_2014.013a9094.png";